import React, { useEffect, useState } from 'react';
import { useApi, identityApiRef } from '@backstage/core-plugin-api';
import { FirebaseNotificationListener } from './FirebaseNotificationListener';

export const SignedInFirebaseNotificationListener = () => {
  const identityApi = useApi(identityApiRef);
  const [isSignedIn, setIsSignedIn] = useState(false);

  useEffect(() => {
    identityApi.getCredentials().then(credentials => {
      if (credentials?.token) {
        setIsSignedIn(true);
      }
    });
  }, [identityApi]);

  if (!isSignedIn) return null;

  return <FirebaseNotificationListener />;
};
